import { useAuth as useAuthContext } from '../contexts/AuthContext';

// Re-export the hook for convenience
export const useAuth = useAuthContext;